<script>
import ModalImagePreview from '@/components/widgets/modal-image-preview.vue';

export default {
  components: { ModalImagePreview },

  props: {
    soalStats: Object,
    listItem: Object,
    currentQuestion: Object,
    is_instruksi: Number,
    mengerjakan: Function,

    currentQuestionOptionList: Object,
    currentQuestionShuffleOptionList: Object,
    answers: Array,
    currentIndex: Number,
    hasImageOptions: Boolean,
    currentPage: Number,
    selectAnswer: Function,

    openProgressFinal: Function,
    nextQuestion: Function,
    nextSoal: Function,
    last_page: Number,
    index_soal: Number,
    status_pengerjaan: Number,
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      abjad: ["A", "B", "C", "D"],
      selectedIndex: null,
      // modal-image-preview
      imagePreview: {
        show: false,
        url: null,
      },
    };
  },

  methods: {
    // modal-image-preview
    openImagePreview(url, event) {
      event.stopPropagation();
      this.imagePreview.url = url;
      this.imagePreview.show = true;
    },
  },
};
</script>

<template>
  <div v-if="currentQuestion && index_soal == 0" class="mym-question-body">
    <!-- TOMBOL MULAI -->
    <div class="pt-3 mb-3">
      <div class="text-center fw-bold">
        <button
          type="button"
          class="mym-btn mym-bg-success w-100"
          @click="nextSoal(0)"
        >
          <i class="fas fa-play me-1"></i>
          MULAI MENGERJAKAN
        </button>
      </div>
    </div>

    <!-- LABEL INSTRUKSI -->
    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          <strong>Instruksi</strong>
        </div>
      </div>

      <div class="mym-question-section">
        <h4>Petunjuk Pilihan Ganda</h4>
        <p>
          Silahkan pilih salah satu jawaban dengan klik pada pilihan jawaban
          yang tersedia.
        </p>
        <p>Klik "preview" untuk menampilkan gambar</p>

        <div class="mb-3">
          <b>Contoh Soal</b>

          <!-- Studi Kasus -->
          <div class="mym-card-case mt-2 mb-3" v-if="currentQuestion?.soal_text">
            <div class="mym-card-jumbotron-header">
              <div class="mym-card-jumbotron-icon text-light">
                <i class="fa fa-file-alt"></i>
              </div>
              <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
            </div>
            <div class="mym-card-jumbotron-content">
              {{ currentQuestion?.soal_text }}
            </div>
          </div>

          <!-- Gambar soal -->
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image mb-3"
          />

          <!-- Pertanyaan -->
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- OPTIONS SECTION -->
    <div class="mym-options-section">
      <div class="mym-options" :class="{ 'grid-mode': hasImageOptions }">
        <div
          v-for="(jawaban, i) in currentQuestionShuffleOptionList"
          :key="i"
          class="mym-option-card"
          :class="{ active: selectedIndex === i }"
          @click="selectedIndex = i"
        >
          <div
            v-if="jawaban?.jawaban && jawaban.jawaban.startsWith('/storage/file_manager')"
            class="option-image-wrapper"
          >
            <img
              :src="BACKEND_URL + jawaban.jawaban"
              class="option-image"
            />
            <button
              class="option-image-preview-btn"
              type="button"
              @click="openImagePreview(BACKEND_URL + jawaban.jawaban, $event)"
            >
              <i class="fas fa-search-plus"></i>
            </button>
          </div>

          <div class="option-content">
            <div class="option-label">
              <span v-if="selectedIndex === i">✔</span>
              <span v-else>{{ abjad[i] }}</span>
            </div>
            <div
              class="option-text"
              v-if="!jawaban?.jawaban || !jawaban.jawaban.startsWith('/storage/file_manager')"
            >
              {{ jawaban?.jawaban }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalImagePreview
    v-model="imagePreview.show"
    :image-url="imagePreview.url"
  />
</template>

<style scoped>
.mym-question-image-wrapper {
  display: flex;
  justify-content: center;
}

.mym-question-image {
  width: 65%;
  height: auto;
}

.option-image-wrapper {
  position: relative;
  display: inline-flex;
  width: 100%;
}

.option-image-wrapper .option-image-preview-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.2s;
  background: rgba(66, 80, 128, 0.55);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mym-option-card:hover .option-image-preview-btn {
  opacity: 1;
}
</style>
